<template>
  <div>
    <main style="max-height: calc(100svh - 125px); overflow-y:auto;">
      <div class="WorkM_MainArea">
        <!-- タイトル欄 -->
        <div class="WorkM_WorkSummaryTitleArea" style="border-bottom: 1px solid rgb(82, 75, 75); padding-bottom: 1rem;">
          <div class="TitleItem_TitleLabel"><b-icon icon="person-check-fill" class="mr-2"></b-icon>承認履歴</div>
        </div>
        <b-container fluid style="max-width: 700px">
          <div class="WorkM_CompleteManagerAporoval">
            <b-tabs 
            fill
            class="mt-3"
            active-nav-item-class="font-weight-bold"
            pills
            justified
            >
              <!-- 申請承認 -->
              <b-tab @click="getApprovalApplicationInfo()" title="事前申請" title-link-class="border border-primary mr-2" active>
                <ApprovalApplicationHistory ref="ApprovalApplicationHistory" :isApprovalHistory=true></ApprovalApplicationHistory>
              </b-tab>
              <!-- 報告承認 -->
              <b-tab @click="getApprovalWorkInfo()" title="報告" title-link-class="border border-primary">
                <ApprovalWorkHistory ref="ApprovalWorkHistory" :isApprovalHistory=true></ApprovalWorkHistory>
              </b-tab>
            </b-tabs>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>

<script>
// import moment from "moment";
import ApprovalApplicationHistory from "../../components/Parts/ApprovalApplicationHistory";
import ApprovalWorkHistory from "../../components/Parts/ApprovalWorkHistory";
export default {
  name: "Manager_ApprovalHistory",
  components: {ApprovalApplicationHistory, ApprovalWorkHistory},
  data() {
    return {
      systemVersion: null,
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.$refs.ApprovalApplicationHistory.getApprovalApplicationInfo();
  },

  methods: {
    getApprovalApplicationInfo: function(){
      this.$refs.ApprovalApplicationHistory.getApprovalApplicationInfo();
    },
    getApprovalWorkInfo: function(){
      this.$refs.ApprovalWorkHistory.getApprovalWorkInfo();
    }
  },
};
</script>
<style>
.WorkM_CompleteAporoval {
  padding: 0 1rem;
}

.ApprovalSelectArea {
  margin-top: 0.5rem;
}

.WorkM_CompleteManagerAporoval .ApprovalFooter{
  margin-bottom: 0 !important; 
  background-color: #ececec !important;
  min-width: 700px!important; 
  right:auto; 
  left:auto;
}
</style>
  